import {
  ACCESS_TOKEN_NAME,
  JSON_CONTENT_TYPE,
} from '../../_constant/constants';
import { RequestDeleteDto } from '../../_dto/_request/RequestDeleteDto';
import { IApiParams } from '../../_interface/IApiParams';
import { getApi } from '../getApi';

export const apiDeleteRequest = async (requestDeleteDto: RequestDeleteDto) => {
  const params: IApiParams = {
    url: '/request/deleteRequest.php',
    headers: {
      'Content-Type': JSON_CONTENT_TYPE,
      'Access-Token': localStorage.getItem(ACCESS_TOKEN_NAME),
    },
  };
  return getApi(params, 'DELETE', requestDeleteDto);
};
